/**
 * Outlook on the web deeplink builders. These open a pre-filled compose window
 * in the user's real Outlook (M365), where they review and send/approve.
 * We never auto-send — these just hand off a draft to Outlook.
 */
const MAIL_BASE = "https://outlook.office.com/mail/deeplink/compose";
const CAL_BASE = "https://outlook.office.com/calendar/deeplink/compose";

export function outlookMailCompose({ to, subject, body, cc } = {}) {
  const p = new URLSearchParams();
  if (to) p.set("to", to);
  if (cc) p.set("cc", cc);
  if (subject) p.set("subject", subject);
  if (body) p.set("body", body);
  return `${MAIL_BASE}?${p.toString()}`;
}

export function outlookCalendarCompose({ subject, start, end, location, body, attendees } = {}) {
  const p = new URLSearchParams();
  if (subject) p.set("subject", subject);
  if (start) p.set("startdt", start);
  if (end) p.set("enddt", end);
  if (location) p.set("location", location);
  if (attendees) p.set("to", attendees);
  if (body) p.set("body", body);
  return `${CAL_BASE}?${p.toString()}`;
}

export function openUrl(url) {
  window.open(url, "_blank", "noopener,noreferrer");
}
